import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VCalendar from 'v-calendar'

// App & Router
import App from './App.vue'
import router from './router.ts'

// Plugins
import vuetify from '@/core/plugins/vuetify'
import { installI18n } from '@/core/plugins/i18n'
import { loadAllLocales } from '@/core/utils/mergeLocales'

// API Setu
// Styles
import '@/assets/styles/main.scss'
import 'v-calendar/dist/style.css'

// Initialize app
async function initApp() {
  const app = createApp(App)

  // Load all locale messages
  const messages = await loadAllLocales()

  // Install plugins in correct order
  app.use(createPinia()) // State management (first, as other plugins might use stores)
  app.use(router) // Routing
  app.use(vuetify) // UI framework
  app.use(VCalendar, { componentPrefix: 'vc' }) // Calendar component

  // Install i18n after loading messages
  installI18n(app, messages)

  // Mount app to DOM
  app.mount('#app')
}

// Start the application
initApp().catch((error) => {
  console.error('Failed to initialize application:', error)
})
